import { Card, CardContent } from '@lombok/ui';
import { PageHeader } from '@/components/PageHeader';
import { useSessionProfile } from '@/auth/useSessionProfile';
import { OrderCreatePage } from './OrderCreatePage';

const ORDERS_PATH = '/app/customer/pedidos';

/** Crear pedido in the customer portal: always for the signed-in customer's own account. */
export function CustomerOrderCreatePage() {
  const { profile } = useSessionProfile();
  const customerId = profile?.customerId;

  if (!customerId) {
    return (
      <div className="flex flex-col gap-6">
        <PageHeader title="Crear pedido" />
        <Card>
          <CardContent className="py-12 text-center text-sm text-text-muted">
            Tu usuario no está vinculado a una cuenta de cliente. Contacta a tu vendedor para poder crear
            pedidos.
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <OrderCreatePage
      basePath={ORDERS_PATH}
      ordersPath={ORDERS_PATH}
      fixedCustomerId={customerId}
      backLabel="Mis pedidos"
    />
  );
}
